<dialog class="modal" #sendActivationKeysDialog>
  <div class="modal-box max-w-3xl">
    <form method="dialog">
      <button
        (click)="closeDialog()"
        class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
      >
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Send Activation Keys</h3>

    <label class="flex cursor-pointer items-center w-fit gap-2 pt-4">
      <input
        type="checkbox"
        class="checkbox-primary checkbox"
        [checked]="isTransfer"
        (change)="toggleTransfer()"
      />
      <span>Send as Transfer Email</span>
    </label>

    <!-- Show licenses list with checkboxes for each license -->
    @if (licenses && licenses.length > 0) {
      <div class="pl-2 pt-4">Licenses:</div>
      <div class="mt-2 rounded-lg border border-base-content/20">
        <div class="overflow-y-auto">
          @for (license of licenses; track license.id) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedLicenses.has(license.id)"
                  (change)="toggleLicense(license.id)"
                  [disabled]="!license.activation_key"
                />
                <span
                  [class.text-gray-500]="!license.activation_key"
                  [class.line-through]="!license.activation_key"
                  >{{ license.product.title }} - Exp.
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                  @if (license.unique_id) {
                    ({{ license.unique_id }})
                  }
                </span>
                @if (!license.activation_key) {
                  <span class="text-sm text-gray-500">
                    No activation key available
                  </span>
                }
              </label>
            </div>
          }
        </div>
      </div>
    }

    @if (loadingStandaloneKeys) {
      <div class="pl-2 pt-4">
        <span class="loading loading-spinner loading-sm"></span>
      </div>
    } @else if (standaloneKeysError) {
      <p class="pl-2 pt-4 text-error">{{ standaloneKeysError }}</p>
    } @else if (standaloneKeys.length > 0) {
      <div class="pl-2 pt-4">One-off Activation Keys:</div>
      <div class="mt-2 rounded-lg border border-base-content/20">
        <div class="overflow-y-auto">
          @for (key of standaloneKeys; track key.id) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedStandaloneKeys.has(key.id)"
                  (change)="toggleStandaloneKey(key.id)"
                />
                <span>
                  {{ standaloneKeyLabel(key) }} - Exp.
                  {{ key.expiration_date | date: 'MM/dd/yyyy' : 'UTC' }}
                  ({{ key.unique_id }})
                </span>
              </label>
            </div>
          }
        </div>
      </div>
    }

    <div class="pl-2 pt-4">Emails:</div>
    <div class="mt-2 rounded-lg border border-base-content/20">
      <div class="overflow-y-auto">
        @if (accountEmails.length > 0) {
          <div class="pl-4 pt-2">Account Emails:</div>
          @for (email of accountEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.has(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }
        @if (billingEmails.length > 0) {
          <div class="pl-4 pt-2">Billing Emails:</div>
          @for (email of billingEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.has(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }

        @if (additionalEmails.length > 0) {
          <div class="pl-4 pt-2">Additional Emails:</div>
          @for (email of additionalEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.has(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }

        <div>
          @if (!isAddingEmail) {
            <button
              class="flex w-full items-center gap-2 px-4 py-2 text-left hover:bg-base-200"
              (click)="isAddingEmail = true"
            >
              <app-plus-icon class="h-4 w-4"></app-plus-icon>
              <span>Add another email</span>
            </button>
          } @else {
            <div class="flex w-full px-4 py-2">
              <div class="join flex w-full">
                <input
                  type="email"
                  class="input input-sm join-item input-bordered flex-1"
                  placeholder="Enter email address"
                  [formControl]="customEmail"
                  (keyup.enter)="addCustomEmail()"
                  (keyup.escape)="cancelAddingEmail()"
                  #emailInput
                />
                <button
                  class="btn btn-outline btn-primary join-item btn-sm"
                  (click)="addCustomEmail()"
                >
                  Add
                </button>
                <button
                  class="btn btn-outline btn-error join-item btn-sm"
                  (click)="cancelAddingEmail()"
                >
                  Cancel
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2 pl-2 pt-4">
      @if (sendingEmail) {
        <div class="loading loading-spinner loading-sm"></div>
      }
      <button
        class="btn btn-primary btn-sm"
        (click)="emailActivationKeys()"
        [disabled]="sendingEmail"
      >
        Email Activation Keys
      </button>
      <button
        class="btn btn-neutral btn-sm"
        (click)="closeDialog()"
        [disabled]="sendingEmail"
      >
        Cancel
      </button>
    </div>
  </div>
</dialog>
